export default __webpack_public_path__ + "static/media/404-Not-Found.72a307b1.svg";